import { SelectedLanguageMode } from '../../conversation/components/integrations/elevio/src/types/elevio.actions';

export function getLocalSettings() {
  const localSettings = localStorage.getItem('localSettings');
  if (localSettings != null) {
    return JSON.parse(localSettings);
  }
  return null;
}

function saveSettings(localSettings: any) {
  return localStorage.setItem('localSettings', JSON.stringify(localSettings));
}

export function updateSettings(payload: {
  key: string;
  value: any;
}): Promise<any> {
  const { key, value } = payload;
  return new Promise((resolve, reject) => {
    try {
      const localSettings = getLocalSettings() || {};
      localSettings[key] = value;
      saveSettings(localSettings);
      return resolve(localSettings);
    } catch (e) {
      return reject(e);
    }
  });
}

export function updateReplyAreaHeight(payload: {
  value: number;
}): Promise<any> {
  return updateSettings({
    key: 'replyAreaHeight',
    value: payload.value,
  });
}

export function toggleStrictSearch(payload: { value: boolean }): Promise<any> {
  return updateSettings({
    key: 'strictSearch',
    value: payload.value,
  });
}

export function toggleRememberMicrophoneAccess(payload: {
  value: boolean;
}): Promise<any> {
  return updateSettings({
    key: 'skipMicrophoneAccess',
    value: payload.value,
  });
}

export function toggleRememberElevioCardOpen(payload: {
  elevioCardOpen: boolean;
}): Promise<any> {
  return updateSettings({
    key: 'elevioCardOpen',
    value: payload.elevioCardOpen,
  });
}

export function toggleElevioSelectedLanguage(payload: {
  elevioSelectedLanguage: SelectedLanguageMode;
}): Promise<any> {
  return updateSettings({
    key: 'elevioSelectedLanguage',
    value: payload.elevioSelectedLanguage,
  });
}

export function toggleRememberKnowledgeCardOpen(payload: {
  knowledgeCardOpen: boolean;
}): Promise<any> {
  return updateSettings({
    key: 'knowledgeCardOpen',
    value: payload.knowledgeCardOpen,
  });
}

export function updateConversationCards(payload: {
  key: string;
  value: boolean;
}): Promise<any> {
  const { conversationCards } = getLocalSettings() || {};
  const { key, value } = payload;

  return updateSettings({
    key: 'conversationCards',
    value: {
      ...conversationCards,
      [key]: value,
    },
  });
}
